module.exports = "<h2 mat-dialog-title>Please wait...</h2>\n<mat-dialog-content>\n  <div class=\"center-block\">\n    <div class=\"loading-icon-inline\">Cards are being processed, this can take a while. <img class=\"center\" src=\"assets/images/loading-grey.svg\"></div>\n  </div>\n</mat-dialog-content>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/loading-dialog/loading-dialog.component.html
// module id = ../../../../../src/app/shared/loading-dialog/loading-dialog.component.html
// module chunks = main